<template>
  <div class="layout-options-config">
    <el-collapse v-model="activeNames" style="width: 100%">
      <el-collapse-item @mousedown.native="collapseMouseDown($event, '1')" title="头部设置" name="1" v-if="request_prefix !== 'appStage' && (!isSubHeadPage || subHeadHasRelativeHeader)">
        <div>
          <el-checkbox v-model="openHeaderRelation">开启头部变换</el-checkbox>
        </div>
        <div class="card mt8" v-if="openHeaderRelation">
          <cx-slider
            label="状态"
            :value.sync="activeType"
            :options="currentActiveTypeOptions"
            @click="clickChangeActiveValue"
          />
          <div class="mt8 card-checkbox" @click.prevent="changeRelativeHeaderNavData" v-if="activeType === '2'">
            <el-checkbox :value="syncHeaderNav">同步默认头部导航数据源</el-checkbox>
          </div>
        </div>
      </el-collapse-item>
      <el-collapse-item
        v-if="layoutOptions.inDocument === 'relativeHeader' && request_prefix !== 'appStage'"
        @mousedown.native="collapseMouseDown($event, '2')"
        title="条件设置"
        name="2"
      >
        <el-radio-group v-model="relativeHeaderRule">
          <div v-for="(item, index) in relativeHeaderRules" :key="index" class="verticallyCenter">
            <el-radio :label="item.label">{{ item.name }}</el-radio>
            <i class="tips-btn icon-portal-info2" v-if="item.tips" @click.stop.prevent="explainDialogClick(item)"></i>
            <div class="fixedTop-inp-wrap" v-show="item.label === 'fixedTop' && relativeHeaderRule === 'fixedTop'">
              <single-input
                class="input-size custom-width-inp mr2"
                placeholder="-"
                style="width: 60px; height: 32px"
                :value.sync="relativeHeaderFixedTop"
                inputSuffixs="px"
              />
              <!--              <el-input-->
              <!--                class="input-size custom-width-inp mr2"-->
              <!--                type="number"-->
              <!--                placeholder="-"-->
              <!--                style="width: 60px; height: 32px"-->
              <!--                v-model="relativeHeaderFixedTop"-->
              <!--                @focus="getFocus($event)"-->
              <!--              >-->
              <!--                <template slot="suffix">-->
              <!--                  <span class="lineHeight32">px</span>-->
              <!--                </template>-->
              <!--              </el-input>-->
              时
            </div>
          </div>
        </el-radio-group>
      </el-collapse-item>
      <el-collapse-item
        v-if="openHeaderRelation && animateOfIn && request_prefix !== 'appStage' && !enableLeftNav"
        @mousedown.native="collapseMouseDown($event, '3')"
        title="进场动画"
        name="3"
      >
        <div class="verticallyCenter">
          <cx-select
            class="effect-select flex1"
            title="效果"
            :selectOptions="animatesOfIn"
            @change="animatesOfInChange"
            :value.sync="animateOfIn.value"
          />
          <cx-select
            v-if="animateOfIn.direction"
            class="effect-select ml12 w72"
            :selectOptions="directions"
            :value.sync="animateOfIn.direction"
          />
        </div>
        <div class="verticallyCenter mt12" v-if="animateOfIn && animateOfIn.value !== 'none'">
          <cx-select
            class="effect-select flex1"
            title="过渡"
            :selectOptions="animateSpeed"
            :value.sync="animateOfIn.speed"
          />
          <single-input
            class="ml12 w72"
            placeholder="-"
            style="height: 32px"
            :value.sync="animateOfIn.duration"
            inputSuffixs="ms"
          />
          <!--          <el-input-->
          <!--            class="ml12 w72"-->
          <!--            type="number"-->
          <!--            placeholder="-"-->
          <!--            style="height: 32px"-->
          <!--            v-model="animateOfIn.duration"-->
          <!--            @focus="getFocus($event)"-->
          <!--          >-->
          <!--            <template slot="suffix">-->
          <!--              <span class="lineHeight32">ms</span>-->
          <!--            </template>-->
          <!--          </el-input>-->
        </div>
        <slider-and-input
          v-if="animateOfIn && animateOfIn.value !== 'none'"
          class="mt16 delay-slider"
          :value.sync="animateOfIn.delay"
          title="延迟"
          :sliderMax="10000"
          :sliderMin="0"
          inputWidth="72"
          suffix="ms"
        />
      </el-collapse-item>
      <el-collapse-item
        v-if="openHeaderRelation && animateOfOut && request_prefix !== 'appStage' && !enableLeftNav"
        @mousedown.native="collapseMouseDown($event, '4')"
        title="出场动画"
        name="4"
      >
        <div class="verticallyCenter">
          <cx-select
            class="effect-select flex1"
            title="效果"
            @change="animatesOfOutChange"
            :selectOptions="animatesOfOut"
            :value.sync="animateOfOut.value"
          />
          <cx-select
            v-if="animateOfOut && animateOfOut.direction"
            class="effect-select ml12 w72"
            :selectOptions="outDirections"
            :value.sync="animateOfOut.direction"
          />
        </div>
        <div class="verticallyCenter mt12" v-if="animateOfOut && animateOfOut.value !== 'none'">
          <cx-select
            class="effect-select flex1"
            title="过渡"
            :selectOptions="animateSpeed"
            :value.sync="animateOfOut.speed"
          />
          <single-input
            class="ml12 w72"
            placeholder="-"
            style="height: 32px"
            :value.sync="animateOfOut.duration"
            inputSuffixs="ms"
          />
          <!--          <el-input-->
          <!--            class="ml12 w72"-->
          <!--            type="number"-->
          <!--            placeholder="-"-->
          <!--            style="height: 32px"-->
          <!--            v-model="animateOfOut.duration"-->
          <!--            @focus="getFocus($event)"-->
          <!--          >-->
          <!--            <template slot="suffix">-->
          <!--              <span class="lineHeight32">ms</span>-->
          <!--            </template>-->
          <!--          </el-input>-->
        </div>
        <slider-and-input
          v-if="animateOfOut && animateOfOut.value !== 'none'"
          class="mt16 delay-slider"
          :value.sync="animateOfOut.delay"
          title="延迟"
          :sliderMax="10000"
          :sliderMin="0"
          inputWidth="72"
          suffix="ms"
        />
      </el-collapse-item>
      <el-collapse-item
        @mousedown.native="collapseMouseDown($event, '1')"
        title="子页面头部"
        name="1"
        v-if="!isSubHeadPage && pageType == 'normal'"
      >
        <div>
          <el-checkbox v-model="enableSubHead" :disabled="!enableSetSubHead"
            >开启子页面头部
            <el-tooltip
              effect="dark"
              placement="top"
            >
              <span slot="content">开启后，所有同步首页头部的<br>子页面头部，都变为此处需要<br>编辑的二级头部</span>
              <i class="icon-portal-info2 subhead-tips-icon"></i> </el-tooltip
          ></el-checkbox>
          <p v-if="isGeneratingSubHeadPage" class="sub-head-tips mt8">
            <i class="icon-portal-loading"></i>正在生成子页面头部
          </p>
        </div>
        <div class="mt8" v-if="subHeadPageId && enableSubHead">
          <div class="childPageSettingBtn" type="primary" @click="editSubHead">编辑子页面头部</div>
        </div>
      </el-collapse-item>
    </el-collapse>
    <el-dialog title="说明" :append-to-body="true" :visible.sync="explainDialog" custom-class="explainDialog">
      <p class="fs14 tips" v-for="(item, index) in explainTextList" :key="index">
        <span>{{ item.explainTitle }}</span
        >{{ item.explainTips }}
      </p>
      <div class="box">
        <!--        <img :src="explainImgSrc" v-if="explainImgSrc" alt="" class="img" />-->
        <!--        <video :src="explainVideoSrc" controls v-if="explainVideoSrc"></video>-->
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { _throttle, _debounce, replaceUrlParam, encryptionWorker, smartMathMax } from "@/utils/index"
import { deepChangeUid, findRectPath } from "utils"
import { handleChildAppid } from "@/utils/reCreatAppid"
import { parseHeader, saveSubHeader } from "@/utils/refHead"
import { buildModel } from "utils/buildModel.js"
import { jsonCompress } from "utils/jsonCompress"
export default {
  name: "header-config",
  props: {
    options: Object
  },
  data() {
    return {
      contextPath: "",
      activeNames: ["1", "2", "3", "4"],
      collapseActiveNames: ["1", "2", "3", "4"],
      this1: this,
      showDialog: false,
      elementList: [],
      btnInfoList: [],
      editInfo: {},
      activeType: "1",
      currentActiveTypeOptions: [
        { value: "1", title: "默认头部" },
        { value: "2", title: "变换头部" }
      ],
      headerPageLayoutId: 0,
      explainDialog: false,
      explainTextList: [],
      relativeHeaderRules: [
        {
          name: "页面滚动时",
          label: "top"
        },
        {
          name: "页面滚动超过首屏时",
          label: "firstScreen",
          tips: "该功能仅在开启整屏切换后生效！"
        },
        {
          name: "页面滚动距离超过",
          label: "fixedTop"
        }
      ],
      animateSpeed: [
        {
          label: "线性",
          value: "linear"
        },
        {
          label: "缓动",
          value: "ease-in"
        },
        {
          label: "缓入",
          value: "ease-in"
        },
        {
          label: "缓出",
          value: "ease-out"
        },
        {
          label: "缓入缓出",
          value: "ease-in-out"
        }
      ],
      outDirections:[
        {
          label: "向左",
          value: "left"
        },
        {
          label: "向右",
          value: "right"
        },
        {
          label: "向上",
          value: "top"
        },
        {
          label: "向下",
          value: "bottom"
        }
      ],
      directions: [
        {
          label: "从左",
          value: "left"
        },
        {
          label: "从右",
          value: "right"
        },
        {
          label: "从上",
          value: "top"
        },
        {
          label: "从下",
          value: "bottom"
        }
      ],
      animatesOfIn: [
        {
          label: "无动画",
          value: "none"
        },
        {
          label: "淡入",
          value: "animate__fadeIn",
          variable: "opacity",
          variableStart: 0,
          variableEnd: 1,
          speed: "linear",
          delay: 200,
          duration: 200
        },
        {
          label: "移入",
          value: "animate__slideIn_",
          variable: "",
          direction: "top",
          variableStart: "-100%",
          variableEnd: "0",
          speed: "linear",
          delay: 200,
          duration: 200
        }
      ],
      animatesOfOut: [
        {
          label: "无动画",
          value: "none"
        },
        {
          label: "淡出",
          value: "animate__fadeOut",
          variable: "opacity",
          variableStart: 1,
          variableEnd: 0,
          speed: "linear",
          delay: 200,
          duration: 200
        },
        {
          label: "移出",
          value: "animate__slideOut_",
          variable: "",
          direction: "top",
          variableStart: "0",
          variableEnd: "-100%",
          speed: "linear",
          delay: 200,
          duration: 200
        }
      ],
      baseComponent: [
        "cxText",
        "cxLabel",
        "imageComponent",
        "cxHomeLine",
        "cxButton",
        "cxEditor",
        "cxShape",
        "cxRadio",
        "cxVideo",
        "cxAudio",
        "cxDigitRoll",
        "cxIcon",
        "cxVerticalLine",
        "cxNoteEditor",
        "cxBreadCrumbs",
        "cxCalendar",
        "cxTabs",
        "cxSelect",
        "cxWeather",
        "cxDate",
        "cxReturn",
        "cxBorder",
        "cxAnimate",
        "cxIframe",
        "cxCode",
        "cxInput",
        "cxAnchorComponent",
        "cxIP"
      ],
      headerNavAppId: undefined,
      isGeneratingSubHeadPage: false,
      enableSetSubHead: true
    }
  },
  comments: {},
  components: {},
  mounted() {
    this.contextPath = window.hasOwnProperty("p_contextpath") ? window["p_contextpath"] : ""
    if (this.layoutOptions.inDocument === "header") {
      this.activeType = "1"
    } else if (this.layoutOptions.inDocument === "relativeHeader") {
      this.activeType = "2"
    }
  },
  watch: {
    activeType(n, o) {
      if (n !== o) {
        this.handleRelativeHeader()
      }
    }
  },
  computed: {
    ids() {
      return this.$store.state.states.activeID
    },
    enableLeftNav(){
        return this.layoutOptions.enableLeftNav || false
    },
    pageType() {
      return this.$store.state[this.request_prefix].type
    },
    isSubHeadPage() {
      return this.$store.state[this.request_prefix].page.isSubHeadPage
    },
    hasRelativeHeader() {
      return this.pageLayoutList.find(item => item.options.inDocument === "relativeHeader")
    },
    subHeadHasRelativeHeader() {
      return this.isSubHeadPage && this.hasRelativeHeader
    },
    layoutOptions() {
      return this.options.options
    },
    headerLayoutOptions() {
      this.headerPageLayoutId = this.pageLayoutList.findIndex(item => item.options.inDocument === "header") || 0
      let headerPageLayout = this.pageLayoutList[this.headerPageLayoutId]
      return headerPageLayout.options
    },
    pageLayoutList: {
      get() {
        return this.$store.state[this.request_prefix].page.pageLayoutList
      },
      set(val) {
        this.$store.dispatch(this.request_prefix + "/changePageLayout", { pageLayoutList: val })
      }
    },
    syncHeaderNav: {
      get() {
        return this.headerLayoutOptions.hasOwnProperty("syncHeaderNav") ? this.headerLayoutOptions.syncHeaderNav : true
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "syncHeaderNav", false, undefined, {
          containerId: this.ids.container_id,
          pageLayoutId: this.headerPageLayoutId
        })
      }
    },
    // openHeaderRelation: {
    //   get() {
    //     return this.headerLayoutOptions.openHeaderRelation || false
    //   },
    //   set(newVal) {
    //     if (!newVal && this.activeType !== "1") {
    //       this.activeType = "1"
    //       this.clickChangeActiveValue()
    //     }
    //     this.$changeOptionsEV(newVal, "openHeaderRelation", false, undefined, {
    //       containerId: this.ids.container_id,
    //       pageLayoutId: this.headerPageLayoutId
    //     })
    //   }
    // },
    useSubHead() {
      return this.$store.state[this.request_prefix].page.useSubHead
    },
    enableSubHead: {
      get() {
        return this.$store.state[this.request_prefix].page?.enableSubHead || false
      },
      set(newVal) {
        if (newVal && this.enableSetSubHead && !this.$store.state[this.request_prefix].page?.enableSubHead) {
          // 如果还没有生成子页面头部页面，要生成一次
          !this.subHeadPageId && this.generateSubHead()
          this.subHeadPageId && this.updateSubHead()
        } else {
          this.enableSetSubHead = false
          this.$confirm(`取消后已经生成的二级头将被重置，是否继续?`, "", {
            confirmButtonText: "确认",
            cancelButtonText: "取消",
            showClose: false,
            closeOnClickModal: false,
            closeOnPressEscape: false,
            dangerouslyUseHTMLString: "",
            iconClass: "bigScreen_confirm_icon el-icon-warning",
            cancelButtonClass: "bigScreen_confirm_cancel_button",
            confirmButtonClass: "bigScreen_confirm_button",
            customClass: "bigScreen_confirm custom_warning_dialog"
          })
            .then(() => {
              this.$changePageAttribute({ option_name: "enableSubHead", option_val: false })
              this.enableSetSubHead = true
            })
            .catch(err => {
              this.enableSetSubHead = true
            })
        }
      }
    },
    subHeadPageId() {
      return this.$store.state[this.request_prefix].page?.subHeadPageId
    },
    openHeaderRelation: {
      get() {
        return this.headerLayoutOptions.openHeaderRelation || false
      },
      set(newVal) {
        if (!newVal && this.activeType !== "1") {
          this.activeType = "1"
          this.clickChangeActiveValue()
        }
        this.$changeOptionsEV(newVal, "openHeaderRelation", false, undefined, {
          containerId: this.ids.container_id,
          pageLayoutId: this.headerPageLayoutId
        })
      }
    },
    relativeHeaderRule: {
      get() {
        return this.headerLayoutOptions.hasOwnProperty("relativeHeaderRule")
          ? this.headerLayoutOptions.relativeHeaderRule
          : "firstScreen"
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "relativeHeaderRule", false, undefined, {
          containerId: this.ids.container_id,
          pageLayoutId: this.headerPageLayoutId
        })
      }
    },
    relativeHeaderFixedTop: {
      get() {
        return this.headerLayoutOptions.hasOwnProperty("relativeHeaderFixedTop")
          ? this.headerLayoutOptions.relativeHeaderFixedTop
          : 0
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "relativeHeaderFixedTop", false, undefined, {
          containerId: this.ids.container_id,
          pageLayoutId: this.headerPageLayoutId
        })
      }
    },
    animateOfIn: {
      get() {
        if (!this.layoutOptions.hasOwnProperty("animateOfIn")) {
          this.$changeOptionsEV(
            JSON.parse(JSON.stringify(this.animatesOfIn[0])),
            "animateOfIn",
            false,
            undefined,
            {
              containerId: this.ids.container_id,
              pageLayoutId: this.ids.pageLayoutId
            },
            true
          )
        }
        return this.layoutOptions.animateOfIn
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "animateOfIn", false)
      }
    },
    currentPageId() {
      return this.$store.state.states.getDataPageIds.pageId
    },
    animateOfOut: {
      get() {
        if (!this.layoutOptions.hasOwnProperty("animateOfOut")) {
          this.$changeOptionsEV(
            JSON.parse(JSON.stringify(this.animatesOfOut[0])),
            "animateOfOut",
            false,
            undefined,
            {
              containerId: this.ids.container_id,
              pageLayoutId: this.ids.pageLayoutId
            },
            true
          )
        }
        return this.layoutOptions.animateOfOut
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "animateOfOut", false, undefined, {
          containerId: this.ids.container_id,
          pageLayoutId: this.ids.pageLayoutId
        })
      }
    },
    subHeadPages() {
      return this.$store.state[this.request_prefix].page?.subHeadPages || []
    }
  },
  methods: {
    // 生成子页面头部
    async generateSubHead(type) {
      this.isGeneratingSubHeadPage = true
      const pcSubHeadPage = parseHeader(this.$store.state["stage"].page)
      buildModel(pcSubHeadPage, 192)
      let pcDatas = await encryptionWorker(pcSubHeadPage)
      pcDatas = JSON.parse(pcDatas)
      pcDatas.page = JSON.parse(JSON.stringify(pcDatas.page).replace(/&quot;/g, "&qquot;"))
      const appSubHeadPage = parseHeader(this.$store.state["appStage"].page)
      buildModel(appSubHeadPage, 41.4)
      let appDatas = await encryptionWorker(appSubHeadPage)
      appDatas = JSON.parse(appDatas)
      appDatas.page = JSON.parse(JSON.stringify(appDatas.page).replace(/&quot;/g, "&qquot;"))
      const tempObj = jsonCompress(pcDatas)
      const appTempObj = jsonCompress(appDatas)
      const portalData = {
        content: tempObj,
        appContent: appTempObj
      }
      const pageId = await saveSubHeader(portalData)
      this.isGeneratingSubHeadPage = false
      this.$changePageAttribute({ option_name: "subHeadPageId", option_val: pageId })
      this.$changePageAttribute({ option_name: "enableSubHead", option_val: true })
      this.$changePageAttribute({
        option_name: "subHeadPages",
        option_val:
          type === "add"
            ? [
                ...this.subHeadPages,
                {
                  originPageId: this.currentPageId,
                  headPageId: pageId
                }
              ]
            : [
                {
                  originPageId: this.currentPageId,
                  headPageId: pageId
                }
              ]
      })
      /**
       * 改变appStage的subHeadPageId和subHeadPages
       */
      this.$store.dispatch("appStage/changeAttribute", { option_name: "subHeadPageId", option_val: pageId })
      this.$store.dispatch("appStage/changeAttribute", {
        option_name: "subHeadPages",
        option_val:
          type === "add"
            ? [
                ...this.subHeadPages,
                {
                  originPageId: this.currentPageId,
                  headPageId: pageId
                }
              ]
            : [
                {
                  originPageId: this.currentPageId,
                  headPageId: pageId
                }
              ]
      })
    },
    async updateSubHead() {
      const stageType = this.request_prefix
      this.isGeneratingSubHeadPage = true
      const newPageStage = parseHeader(this.$store.state[stageType].page)
      buildModel(newPageStage, stageType === "stage" ? 192 : 41.4)
      let datas = await encryptionWorker(newPageStage)
      datas = JSON.parse(datas)
      datas.page = JSON.parse(JSON.stringify(datas.page).replace(/&quot;/g, "&qquot;"))
      const tempObj = jsonCompress(datas)
      const portalData = {
        [stageType === "stage" ? "content" : "appContent"]: tempObj
      }
      await saveSubHeader(portalData, this.subHeadPageId)
      this.isGeneratingSubHeadPage = false
      this.$changePageAttribute({ option_name: "enableSubHead", option_val: true })
    },
    // 编辑子页面头部
    editSubHead() {
      let newUrl = replaceUrlParam(window.location.href, "p", this.subHeadPageId)
      const managerType = this.$store.state.states?.managerType
      newUrl = managerType == 1 ? replaceUrlParam(newUrl, "managerType", 1) : newUrl
      newUrl += "&isSubHeadPage=true"
      window.open(newUrl, "_blank")
    },
    clickChangeActiveValue() {
      // 标识作为切换头部关联样式后，保留toolbar设置项的激活状态
      sessionStorage.setItem("changeHeaderType", true)
    },
    collapseMouseDown($event, val) {
      if ($event.target.classList[0] === "el-collapse-item__header") {
        const _index = this.collapseActiveNames.findIndex(it => it === val)
        _index === -1 ? this.collapseActiveNames.push(val) : ""
      }
    },
    getFocus(event) {
      event.currentTarget.select()
    },
    // 切换头部、关联头部
    async handleRelativeHeader() {
      const page = this.$store.state[this.request_prefix].page
      let relativePageLayoutIndex = page.pageLayoutList.findIndex(
        pageLayout => pageLayout.options.inDocument === "relativeHeader"
      )
      const header = page.pageLayoutList.find(pageLayout => pageLayout.options.inDocument === "header")
      const headerIndex = page.pageLayoutList.findIndex(pageLayout => pageLayout.options.inDocument === "header")
      if (this.activeType === "2") {
        // 切换到关联头部
        if (relativePageLayoutIndex === -1) {
          let tempLayout = JSON.parse(JSON.stringify(header))
          tempLayout.id = this.getNewLayoutId()
          // 栅格模式需要替换组件的栅格id
          let gridLayout = tempLayout.layout.rows[0]?.options?.gridLayout
          let gridLayoutIds = []
          if (gridLayout) {
            gridLayout.forEach((item, index) => {
              let newId = this.uuid.v1()
              gridLayoutIds.push({
                oldId: item.i,
                newId: newId
              })
              item.i = newId
            })
          }
          tempLayout.options.isShow = true
          tempLayout.options.inDocument = "relativeHeader"
          await this.getRect(tempLayout, tempLayout, gridLayoutIds)
          this.pageLayoutList.splice(1, 0, tempLayout)
          relativePageLayoutIndex = 1
          this.$store.dispatch(this.request_prefix + "/changePageLayout", { pageLayoutList: this.pageLayoutList })
        } else {
          this.$changeOptionsEV(true, "isShow", false, undefined, {
            containerId: this.ids.container_id,
            pageLayoutId: relativePageLayoutIndex
          })
        }
        this.$changeOptionsEV(false, "isShow", false, undefined, {
          containerId: this.ids.container_id,
          pageLayoutId: headerIndex
        })
        if (this.layoutOptions.inDocument === 'header') {
          // 只在当前头部为原始头的情况下触发修改ids, 不然修改会导致整个设置组件重新渲染，从mounted 1改2，导致watch又触发，引起嵌套渲染
          this.$store.commit("states/changeActiveID", {
            container_id: this.ids.container_id,
            pageLayoutId: relativePageLayoutIndex
          })
        }
      } else {
        this.$changeOptionsEV(true, "isShow", false, undefined, {
          containerId: this.ids.container_id,
          pageLayoutId: headerIndex
        })
        this.$changeOptionsEV(false, "isShow", false, undefined, {
          containerId: this.ids.container_id,
          pageLayoutId: relativePageLayoutIndex
        })
        this.$store.commit("states/changeActiveID", { container_id: this.ids.container_id, pageLayoutId: headerIndex })
      }
    },
    // 获取rect
    async getRect(col, originLayout, gridLayoutIds) {
      if (col.layout.rows.length > 0) {
        col.layout.rows?.forEach(layout => {
          this.getRect(layout, originLayout, gridLayoutIds)
        })
      } else if (col.layout.cols.length) {
        col.layout.cols?.forEach(layout => {
          this.getRect(layout, originLayout, gridLayoutIds)
        })
      } else {
        if (col.rectIds.length > 0) {
          for (let i = 0; i < col.rectIds.length; i++) {
            let rectAttr = this.getAttrById(
              this.$store.state[this.request_prefix],
              {
                container_id: this.ids.container_id,
                rect_id: col.rectIds[i]
              },
              "rect"
            )
            let gridLayoutId = gridLayoutIds?.find(item => item.oldId === rectAttr.i)?.newId
            await this.addNewRect({
              rectAttr: rectAttr,
              cellRect: col.rectIds,
              index: i,
              type: "edit",
              isClone: true,
              originLayout: originLayout,
              gridLayoutId: gridLayoutId
            })
          }
        }
      }
    },
    getNewLayoutId() {
      let id = 1
      this.pageLayoutList.forEach(item => {
        id = item.id && item.id >= id ? item.id + 1 : id
      })
      // 不存在的话，默认为null，转为number后为0。之所以要存储在本地，是因为有可能组件已经删除，新增布局，恢复后id会重复
      const maxLayoutId = sessionStorage.getItem("maxLayoutId")
      id = Math.max(id, +maxLayoutId)
      sessionStorage.setItem("maxLayoutId", id + 1)
      return id
    },
    // 新加入rect
    async addNewRect(param) {
      let rectAttr = JSON.parse(JSON.stringify(param.rectAttr))
      rectAttr.i = param.gridLayoutId
      deepChangeUid(rectAttr)
      // 单元格里不能放布局通栏
      if (param.type === "new") {
        if (
          this.baseComponent.indexOf(rectAttr.shape) > -1 ||
          // 特殊情况，自由布局组件，带“ListPageSearchComponentPlugin”插件的组件，作为基础组件处理
          (rectAttr.options.pluginName && rectAttr.options.pluginName.indexOf("ListPageSearchComponentPlugin") > -1)
        ) {
          // 基础元素，支持在col内自由拖拽
          rectAttr.options.top = 0
          rectAttr.options.left = 0
          rectAttr.options.zIndex = 2
          // 拖入横向标签布局时不重置布局的高度
          if (!(rectAttr.shape === "cxTabs" && rectAttr.options.isPageLayoutTabs)) {
            this.changeCellSize(param.parentIndex, undefined, rectAttr.options.height)
          }
        } else {
          this.changeCellSize(param.parentIndex, undefined, rectAttr.options.height)
          // 一个col里面只能放一个组件（非基础元素）
          rectAttr.options.top = 0
          rectAttr.options.left = 0
          rectAttr.options.width = 100
          rectAttr.options.widthType = "%"
          rectAttr.options.zIndex = 1
          rectAttr.options.draggable = false
          rectAttr.options.resizable = false
        }
      }
      // 判断是不是勾选的关联 头部导航
      let isHeaderNav = false
      let headComponentMap = this.layoutOptions.headComponentMap
      if (headComponentMap && typeof headComponentMap.nav === "number") {
        isHeaderNav = rectAttr.shape === "cxNavMenu" && rectAttr.rect_id == headComponentMap.nav ? true : false
      } else if (rectAttr.shape === "cxNavMenu") {
        // 没有勾选对应的导航组件 判断是否是第一个导航组件  是的话就将当前的rectId 写入 headComponentMap
        // 此时是复制一个头部通栏  所以如果改变headComponentMap 则是改变原来头部通栏的 headComponentMap
        isHeaderNav = true
        this.$changeOptionsEV(rectAttr.rect_id, "headComponentMap.nav", false)
      }
      // 如果当前数据中存在appId判断当前组件是否是系统保存好的样式
      if (!isHeaderNav && (rectAttr.options.myFetchParam?.appId || rectAttr.options.appId)) {
        //更新appid
        const appId = rectAttr.options.appId ? rectAttr.options.appId : rectAttr.options.myFetchParam?.appId
        // 需要判断当前组件类型，如果是基于自由布局开发的搜索组件/导航菜单，需要特殊处理
        const isSearchComponent = rectAttr.options.pluginName?.includes("searchComponentPlugin")
        const isNavComponent = rectAttr.shape.toLowerCase().includes("nav")
        this.$styleToSaveModule("31CB73E03E24BBFF", "临时", appId, param.isClone, isSearchComponent, isNavComponent)
          .then(res => {
            if (!!res.appId) {
              // 没有myfetchparam的组件 比如搜索组件 更新appId
              rectAttr.options.appId = res.appId
              // if (rectAttr?.options?.myFetchParam) {
              //   //如果拖入画布的组件有，myfetchparam，证明是自由布局或者轮播
              //   //则pageId,wfwfid,websiteId,更新为当前页面的值，防止老组件id不兼容
              //   const { pageId, wfwfid, websiteId } = this.$store.state.states.getDataPageIds
              //   rectAttr.options.appId = res.appId
              //   rectAttr.options.moduleId = res.moduleId
              //   rectAttr.options.myFetchParam.pageId = pageId
              //   rectAttr.options.myFetchParam.wfwfid = wfwfid
              //   rectAttr.options.myFetchParam.websiteId = websiteId
              //   rectAttr.options.myFetchParam.appId = res.appId
              // }
              // 克隆的组件需要将原组件的子页面相关id清空
              if (param.isClone) {
                delete rectAttr.options.detailPageId
                delete rectAttr.options.detailPageTemplateEncId
                delete rectAttr.options.listPageId
                delete rectAttr.options.listPageTemplateEncId
              }
              const params = {
                containerID: this.id,
                data: rectAttr
              }
              // 先删除后面再添加，避免add过程失败，复制的组件id未变
              let newIndex = param.index
              param.cellRect.splice(newIndex, 1)
              this.$store.dispatch(this.request_prefix + "/addElement", params)

              const allRects = this.getAttrById.call(this, this.$store.state[this.request_prefix], {
                container_id: this.id
              }).children
              // let _rect_id = allRects.length ? allRects[allRects.length - 1].rect_id : -1
              let _rect_id = -1
              if (allRects.length > 0) {
                _rect_id = smartMathMax(
                  ...allRects.map(function (o) {
                    return o.rect_id
                  })
                )
              }
              let rect_id = _rect_id
              // this.activateEv(this.id, rect_id, rectAttr.shape)
              if (typeof newIndex !== "undefined") {
                param.cellRect.splice(newIndex, 0, rect_id)
              } else {
                param.cellRect.push(rect_id)
              }
            }
          })
          .catch(err => {
            console.log(err)
          })
      } else {
        const params = {
          containerID: this.ids.container_id,
          data: rectAttr
        }
        this.$store.dispatch(this.request_prefix + "/addElement", params)
        let newIndex = param.index
        const allRects = this.getAttrById.call(this, this.$store.state[this.request_prefix], {
          container_id: this.ids.container_id
        }).children
        let _rect_id = -1
        if (allRects.length > 0) {
          _rect_id = smartMathMax(
            ...allRects.map(function (o) {
              return o.rect_id
            })
          )
        }
        let rect_id = _rect_id
        //  新增导航组件写进新的headComponentMap
        if (isHeaderNav) {
          if (param.originLayout.options.headComponentMap) {
            param.originLayout.options.headComponentMap.nav = rect_id
          } else {
            param.originLayout.options.headComponentMap = {
              nav: rect_id
            }
          }
        }
        if (typeof newIndex !== "undefined") {
          param.cellRect.splice(newIndex, 1, rect_id)
        } else {
          param.cellRect.push(rect_id)
        }
      }
      handleChildAppid.call(this, rectAttr, this.ids.container_id)
      // const lowerShape = rectAttr.shape.toLowerCase()
      //如果是自由布局组件 那就要检测自由布局组件内的组件是否有appid
      // if (lowerShape.includes("layout")) {
      //   const allElementInLayout = getAllElementsInColsInLayoutComponent(rectAttr.options.rows)
      //   for (let uid in allElementInLayout) {
      //     const col = allElementInLayout[uid]
      //     col.elementInLayout &&
      //       Array.isArray(col.elementInLayout) &&
      //       col.elementInLayout.forEach(elementInLayout => {
      //         if (elementInLayout.appId) {
      //           const { elementInLayoutId } = elementInLayout
      //           this.$saveModule(
      //             { container_id: this.ids.container_id, rect_id: rectAttr.rect_id, uid, elementInLayoutId },
      //             "31CB73E03E24BBFF",
      //             "临时",
      //             false,
      //             elementInLayout.appId
      //           )
      //         }
      //       })
      //   }
      // }
    },
    // 拖入应用之后改变外层壳子的尺寸
    changeCellSize(parentIndex, width, height) {
      if (this.request_prefix === "bigScreen") {
        // 大屏的格子高度不随组件改变
        return
      }
      let targetHeight
      if (!width) {
        // targetHeight = Math.max(height ,this.pageLayoutList[parentIndex].options.height)
        targetHeight = height
      } else {
        targetHeight = this.$el.getBoundingClientRect().width * (height / width)
      }
      this.pageLayoutList[parentIndex].options.height = targetHeight
      this.pageLayoutList[parentIndex].layout.rows[0].options.height = targetHeight
    },
    //  取消变换头部的头部导航的数据关联
    changeRelativeHeaderNavData() {
      let flag = !this.syncHeaderNav
      let relativeHeader = this.pageLayoutList.find(item => item.options.inDocument === "relativeHeader")
      let relativeHeaderNav = []
      this.getHeaderNav(relativeHeader, relativeHeaderNav)
      if (relativeHeaderNav.length === 0) {
        return
      }
      // 查看内置的头部导航组件，找不到则取第一个
      let relativeNav = relativeHeaderNav.find(nav => nav.rect_id === relativeHeader.options.headComponentMap?.nav)
      if (!relativeNav) {
        relativeNav = relativeHeaderNav[0]
        // todo 自动布局下的导航获取rect_id的方式不一样了
        this.$changeOptionsEV(relativeNav.rect_id, "headComponentMap.nav", false)
      }
      if (!flag) {
        this.$confirm(
          "取消同步后，将保留现有导航数据并重置子页面模板为默认样式，支持进入导航菜单的数据管理页面对数据进行调整，请确认是否取消?",
          "",
          {
            confirmButtonText: "确认",
            cancelButtonText: "取消",
            showClose: false,
            iconClass: `${this.request_prefix}_confirm_icon el-icon-warning`,
            cancelButtonClass: `${this.request_prefix}_confirm_cancel_button`,
            confirmButtonClass: `${this.request_prefix}_confirm_button`,
            customClass: `${this.request_prefix}_confirm custom_warning_dialog`
          }
        ).then(() => {
          this.generateNewModule(relativeNav)
          this.syncHeaderNav = flag
        })
        return
      }
      this.getHeaderNavAppid()
      //  此时头部的导航组件未绑定外接数据源 或者是未找到
      if (typeof this.headerNavAppId === "undefined") {
        this.$message({
          customClass: "bigScreen_msg_backGroud",
          duration: 3000,
          type: "info",
          message: "请给默认头部的导航菜单导入数据后，再开启同步默认头部导航数据源！"
        })
      } else {
        // 关联数据 将appId修改为  moduleID 是否需要同步过来
        this.$confirm("开启同步后，默认头部的导航菜单数据将覆盖现有数据，请确认是否开启？", "", {
          confirmButtonText: "确认",
          cancelButtonText: "取消",
          showClose: false,
          iconClass: `${this.request_prefix}_confirm_icon el-icon-warning`,
          cancelButtonClass: `${this.request_prefix}_confirm_cancel_button`,
          confirmButtonClass: `${this.request_prefix}_confirm_button`,
          customClass: `${this.request_prefix}_confirm custom_warning_dialog`
        }).then(() => {
          this.$changeOptionsEV(this.headerNavAppId, "appId", false, undefined, {
            container_id: this.ids.container_id,
            rect_id: relativeNav.rect_id,
            path: relativeNav.options.path,
            elementInAutoLayoutId: relativeNav.options.elementInAutoLayoutId
          })
          if (relativeNav.options.myFetchParam?.appId) {
            this.$changeOptionsEV(this.headerNavAppId, "myFetchParam.appId", false, undefined, {
              container_id: this.ids.container_id,
              rect_id: relativeNav.rect_id,
              path: relativeNav.options.path,
              elementInAutoLayoutId: relativeNav.options.elementInAutoLayoutId
            })
          }
          this.syncHeaderNav = flag
        })
      }
    },
    // 原组件存在，仅仅是生成新的appId
    generateNewModule(rectAttr) {
      //更新appid
      const appId = rectAttr.options.appId ? rectAttr.options.appId : rectAttr.options.myFetchParam?.appId
      // 需要判断当前组件类型，如果是基于自由布局开发的搜索组件/导航菜单，需要特殊处理
      const isSearchComponent = rectAttr.options.pluginName?.includes("searchComponentPlugin")
      const isNavComponent = rectAttr.shape.toLowerCase().includes("nav")
      this.$styleToSaveModule("31CB73E03E24BBFF", "临时", appId, true, isSearchComponent, isNavComponent)
        .then(res => {
          if (!!res.appId) {
            // 没有myfetchparam的组件 比如搜索组件 更新appId
            // rectAttr.options.appId = res.appId
            this.$changeOptionsEV(res.appId, "appId", false, undefined, {
              container_id: this.ids.container_id,
              rect_id: rectAttr.rect_id,
              path: rectAttr.options.path,
              elementInAutoLayoutId: rectAttr.options.elementInAutoLayoutId
            })
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    // 获取头部导航的appid
    getHeaderNavAppid() {
      if (this.layoutOptions.inDocument !== "header" && this.layoutOptions.inDocument !== "relativeHeader") {
        return
      }
      let headerPageLayout = this.pageLayoutList.find(item => item.options.inDocument === "header")
      // 如果已经勾选了内置导航组件则用指定的导航组件，否则使用第一个导航组件
      if (
        headerPageLayout &&
        headerPageLayout.options.headComponentMap &&
        headerPageLayout.options.headComponentMap.length > 0 &&
        !isNaN(Number(headerPageLayout.options.headComponentMap.nav))
      ) {
        const navAttrId = headerPageLayout.options.headComponentMap.nav
        const allRects = this.getAttrById.call(this, this.$store.state[this.request_prefix], {
          container_id: this.ids.container_id
        }).children
        let rect = this.getAttrById.call(
          this,
          this.$store.state[this.request_prefix],
          findRectPath(allRects, "nav", navAttrId),
          "rect"
        )
        if (rect.shape === "cxAutoLayout") {
          this.headerNavAppId = null
          this.findRectAppidInAutoLayout(rect.options.elementOptions)
        } else {
          this.headerNavAppId = rect?.options?.appId
        }
      } else {
        let headerNav = []
        this.getHeaderNav(headerPageLayout, headerNav)
        if (headerNav.length > 0) {
          this.headerNavAppId = headerNav[0].options.appId
        }
      }
    },
    findRectAppidInAutoLayout(elementOptions) {
      if (this.headerNavAppId) {
        return
      }
      let nav = elementOptions.find(options => options.innerElement === "cxNavMenu")
      if (nav) {
        this.headerNavAppId = nav.appId
      } else {
        let cxAutoLayout = elementOptions.filter(options => options.innerElement === "cxAutoLayout")
        cxAutoLayout?.forEach(item => {
          this.findRectAppidInAutoLayout(item.elementOptions)
        })
      }
    },
    // 获取通栏中的导航组件
    getHeaderNav(pageLayout, relativeHeaderNav) {
      if (pageLayout.layout.rows?.length > 0) {
        pageLayout.layout.rows.forEach(layout => {
          this.getHeaderNav(layout, relativeHeaderNav)
        })
      } else if (pageLayout.layout.cols?.length) {
        pageLayout.layout.cols.forEach(layout => {
          this.getHeaderNav(layout, relativeHeaderNav)
        })
      } else {
        if (pageLayout.rectIds.length > 0) {
          for (let i = 0; i < pageLayout.rectIds.length; i++) {
            let rectAttr = this.getAttrById(
              this.$store.state[this.request_prefix],
              {
                container_id: this.ids.container_id,
                rect_id: pageLayout.rectIds[i]
              },
              "rect"
            )
            if (rectAttr && rectAttr.shape.toLowerCase().includes("nav")) {
              relativeHeaderNav.push(rectAttr)
            } else if (rectAttr && rectAttr.shape.toLowerCase().includes("cxautolayout")) {
              // 导航组件在自动布局下
              this.findRectInAutoLayout(rectAttr.options.elementOptions, relativeHeaderNav, rectAttr.rect_id)
            }
          }
        }
      }
    },
    findRectInAutoLayout(elementOptions, relativeHeaderNav, rect_id) {
      elementOptions.forEach(rect => {
        if (rect.innerElement === "cxAutoLayout") {
          this.findRectInAutoLayout(rect.elementOptions, relativeHeaderNav, rect_id)
        } else if (rect.innerElement === "cxNavMenu") {
          relativeHeaderNav.push({
            rect_id: rect_id,
            shape: "cxNavMenu",
            options: {
              ...rect
            }
          })
        }
      })
    },
    animatesOfInChange(val) {
      this.animateOfIn = JSON.parse(JSON.stringify(this.animatesOfIn.find(item => item.value === val)))
    },
    animatesOfOutChange(val) {
      this.animateOfOut = JSON.parse(JSON.stringify(this.animatesOfOut.find(item => item.value === val)))
    },
    explainDialogClick(item) {
      this.explainDialog = true
      this.explainTextList = [
        {
          explainTitle: "",
          explainTips: item.tips
        }
      ]
    }
  }
}
</script>

<style scoped lang="scss">
.childPageSettingBtn {
  background: var(--leftMenuBgColor);
  border: 1px solid var(--themeColor);
  border-radius: 4px;
  font-size: 13px;
  line-height: 18px;
  text-align: center;
  color: var(--themeColor);
  padding: 5px 0;
  display: flex;
  justify-content: center;
  align-items: center;
  &:not(.disabledBtn):hover {
    background: var(--defaultButtonHover);
    cursor: pointer;
  }
  &.is_disabled {
    background: var(--defaultButtonHover);
  }
  .icon-portal-loading1 {
    display: inline-block;
    margin-right: 4px;
    transform: rotate(90deg);
    font-size: 14px;
    color: var(--topOperationAColor);
    vertical-align: middle;
    margin-top: -2px;
    animation: rotation 1s linear infinite;
    &:before {
      color: var(--topOperationAColor);
    }
  }
  &.disabledBtn {
    cursor: not-allowed;
    border: 1px solid var(--themeColorDisabled);
    color: var(--themeColorDisabled);
  }
}
.card-checkbox {
  margin-left: 38px;
}

.layout-options-config .card {
  padding: 12px;
}

::v-deep.layout-options-config .card .title {
  margin-right: 12px;
}

::v-deep.layout-options-config .card-checkbox .el-checkbox__label {
  font-size: 13px;
  color: rgba(0, 0, 0, 1);
}

.fixedTop-inp-wrap {
  display: inline-block;
  font-size: 14px;
  color: var(--textColor);
}

.lineHeight32 {
  display: inline-block;
  line-height: 32px;
}
.w72 {
  width: 72px;
}
::v-deep .delay-slider .slider_size {
  margin-left: 4px;
}
.tips-btn {
  margin-left: -8px;
}
.sub-head-tips {
  font-size: 14px;
  color: #c0c0c0;
  .icon-portal-loading {
    font-size: 14px;
  }
}
.subhead-tips-icon {
  vertical-align: -1px;
  margin-left: 2px;
  &:hover {
    color: var(--themeColor);
  }
}
</style>
